export const iconFontAwesomeHumanitarianToilet = (
	<i className="fa-solid fa-toilet"></i>
);
